import React from 'react';
import BrokerageLoginForm from 'Components/Banking/BrokerageLoginForm';
import useEscapeToClose from 'Components/Banking/useEscapeToClose';
import applyBrokerageSession from 'Components/Banking/applyBrokerageSession';
import './Brokerage.css';

// Streichen ODER Aendern (Limit/Gueltigkeit) einer bestehenden Order (Doku
// Kapitel 7.1.9/7.1.11/7.1.12, Chat vom 2026-07-26) - spiegelt denselben Ablauf
// wie BrokerageOrderForm.js fuer neue Orders. Die comdirect-Verbindung bleibt
// seit dem Umbau vom 2026-07-26 (Nutzervorgabe) nach der Aktion bestehen,
// statt sofort widerrufen zu werden - Schliessen laeuft nur noch explizit
// ueber den Logout in der Top-Navigation (BrokerageTask::syncBrokerageData()).
export default function BrokerageOrderAction(props) {

	const x = props.x;
	const task = (name, data, cb) => x.was.axPost('Backend/webapp.php?module=Banking&task=' + name, data, cb);
	const order = props.order;
	const isChange = props.action === 'change';

	// Handelsplatz nimmt nur tagesgueltige Orders an - siehe
	// BrokerageTask::DAY_ONLY_VENUE_NAMES (das Flag kommt fertig ausgewertet
	// vom Backend mit der Orderliste).
	const dayOnly = !!order.dayOnlyVenue;

	const [limitPrice, setLimitPrice] = React.useState(order.limit && order.limit.value !== undefined ? String(order.limit.value) : '');
	const [validityType, setValidityType] = React.useState(dayOnly ? 'GFD' : (order.validityType || 'GFD'));
	const [validity, setValidity] = React.useState(order.validity || '');
	const [needsLogin, setNeedsLogin] = React.useState(false);
	const [autoSubmitting, setAutoSubmitting] = React.useState(false);
	const [challenge, setChallenge] = React.useState(null);
	const [tanCode, setTanCode] = React.useState('');
	const [busy, setBusy] = React.useState(false);
	const [error, setError] = React.useState('');

	useEscapeToClose(props.onCancel);

	function submitPreview() {
		setBusy(true);
		setError('');
		const data = { connectionId: props.connectionId, orderId: order.orderId, action: props.action };
		if (isChange) {
			data.limitPrice = limitPrice;
			data.validityType = validityType;
			data.validity = validityType === 'GTD' ? validity : '';
		}
		task('BrokerageOrderActionPreview', data, (result) => {
			setBusy(false);
			setAutoSubmitting(false);
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				if (content.status === 'login-required') {
					setNeedsLogin(true);
					return;
				}
				setError(content.message || 'Aktion fehlgeschlagen.');
				return;
			}
			if (content.status === 'tan-required') {
				setChallenge({ type: content.challengeType });
				setTanCode('');
				return;
			}
			applyBrokerageSession(x, content);
			x.wah.addHint(isChange ? 'Order geändert.' : 'Order gestrichen.');
			props.onDone();
		});
	}

	// Streichen braucht keine Eingabe - direkt beim Oeffnen anstossen. Aendern
	// zeigt erst die Eingabemaske, submitPreview() laeuft dort erst nach Klick.
	React.useEffect(() => {
		if (!isChange) submitPreview();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function submitTan() {
		setBusy(true);
		setError('');
		task('BrokerageOrderActionConfirm', { connectionId: props.connectionId, tanCode }, (result) => {
			setBusy(false);
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				setError(content.message || 'Bestätigung fehlgeschlagen.');
				return;
			}
			applyBrokerageSession(x, content);
			x.wah.addHint(isChange ? 'Order geändert.' : 'Order gestrichen.');
			props.onDone();
		});
	}

	if (needsLogin) {
		return (
			<BrokerageLoginForm
				x={x}
				connectionId={props.connectionId}
				accountLabel={props.accountLabel}
				pinUse={true}
				pinStored={!!props.pinStored}
				purpose="order"
				onLoggedIn={() => { setNeedsLogin(false); setAutoSubmitting(true); submitPreview(); }}
				onCancel={props.onCancel}
			/>
		);
	}

	if (autoSubmitting) {
		return (
			<div className="brokerage-card">
				{props.onCancel && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onCancel}></i>}
				<p className="brokerage-hint"><i className="bi bi-arrow-repeat"></i> Wird gesendet…</p>
			</div>
		);
	}

	if (challenge !== null) {
		const needsCode = challenge.type === 'M_TAN';
		return (
			<div className="brokerage-card">
				{props.onCancel && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onCancel}></i>}
				{challenge.type === 'P_TAN_PUSH' && !busy &&
					<p className="brokerage-hint"><i className="bi bi-phone"></i> Bitte in der comdirect-App bestätigen.</p>
				}
				{needsCode &&
					<React.Fragment>
						<label htmlFor="brokerage-orderaction-tan">TAN</label>
						<input
							id="brokerage-orderaction-tan"
							type="text"
							autoComplete="off"
							value={tanCode}
							onChange={(e) => setTanCode(e.target.value)}
							onKeyDown={(e) => { if (e.key === 'Enter') submitTan(); }}
							autoFocus
						/>
					</React.Fragment>
				}
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				<div className="brokerage-actions">
					{/* Bei PushTAN meldet der Klick eine BEREITS in der comdirect-App
					    erfolgte Freigabe - deshalb Vergangenheitsform (Nutzervorgabe,
					    Chat vom 2026-08-11, analog BrokerageLoginForm.js). Bei mTAN
					    wird hier und jetzt mit dem eingegebenen Code bestaetigt, da
					    bleibt es beim Imperativ. */}
					<button type="button" className="btn" disabled={busy || (needsCode && tanCode === '')} onClick={submitTan}>
						{busy ? 'Bestätige…' : (isChange
							? (needsCode ? 'Änderung bestätigen' : 'Änderung bestätigt')
							: (needsCode ? 'Streichung bestätigen' : 'Streichung bestätigt'))}
					</button>
				</div>
			</div>
		);
	}

	if (!isChange) {
		return (
			<div className="brokerage-card">
				{props.onCancel && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onCancel}></i>}
				<p className="brokerage-hint"><i className="bi bi-arrow-repeat"></i> Order wird gestrichen…</p>
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
			</div>
		);
	}

	return (
		<div className="brokerage-card">
			{props.onCancel && <i className="bi bi-x-lg brokerage-card-close" title="Schließen" onClick={props.onCancel}></i>}
			<div className="brokerage-field-row">
				<label>Wertpapier</label>
				<p className="brokerage-instrument-label">{order.instrumentName || order.instrumentId}</p>
			</div>
			<div className="brokerage-field-row">
				<label>Limit ({(order.limit && order.limit.unit) || 'EUR'})</label>
				<input
					type="number"
					min="0"
					step="0.01"
					value={limitPrice}
					onChange={(e) => setLimitPrice(e.target.value)}
					onKeyDown={(e) => { if (e.key === 'Enter' && !busy && limitPrice !== '') submitPreview(); }}
				/>
			</div>
			{/* Handelsplaetze, die nur tagesgueltige Orders annehmen (z.B.
			    "Vor-/Nachbörslich USA", Nutzermeldung Chat vom 2026-08-10),
			    bekommen gar keine Auswahl - das Feld zeigt dann nur den festen
			    Wert. Das Flag kommt vom Backend (BrokerageLocalOrderList.inc),
			    damit die Liste dieser Handelsplaetze an EINER Stelle gepflegt
			    wird (BrokerageTask::DAY_ONLY_VENUE_NAMES). */}
			<div className="brokerage-field-row">
				<label>Gültig bis</label>
				{dayOnly
					? <p className="brokerage-instrument-label">Tagesgültig<span className="brokerage-hint"> – {order.venueName} nimmt nur tagesgültige Orders an.</span></p>
					: <select value={validityType} onChange={(e) => setValidityType(e.target.value)}>
						<option value="GFD">Tagesgültig</option>
						<option value="GTD">GTC</option>
					</select>
				}
			</div>
			{validityType === 'GTD' &&
				<div className="brokerage-field-row">
					<label>Datum</label>
					<input
						type="date"
						value={validity}
						onChange={(e) => setValidity(e.target.value)}
						onKeyDown={(e) => { if (e.key === 'Enter' && !busy && limitPrice !== '') submitPreview(); }}
					/>
				</div>
			}
			{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
			<div className="brokerage-actions">
				<button type="button" className="btn" disabled={busy || limitPrice === ''} onClick={submitPreview}>
					{busy ? 'Sende…' : 'Änderung absenden'}
				</button>
			</div>
		</div>
	);
}
